import axios from 'axios';
import router from '../Routes';

export default {
  namespaced: true,
  state: {
    salesreports: [],
    isFetching: false,
    isReceiving: false,
    hasAlert: false,
    isDone: false,
    errorMessage: '',
    idToDelete: null,
  },
  mutations: {
    DELETED_SALESREPORT(state, payload) {
      let indexToDelete = state.salesreports.findIndex(salesreport => salesreport._id === payload._id);
      console.log(indexToDelete);
      let salesreports = [...state.salesreports];
      salesreports.splice(indexToDelete, 1);
      state = Object.assign(state, {
        salesreports: [...salesreports],
        isDeleting: false,
        idToDelete: null,
      });
    },
    DELETING_SALESREPORT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload._id;
    },
    RECEIVED_SALESREPORTS(state, payload) {
      state.salesreports = payload;
      state.isReceiving = false;
    },
    STOP_RECEIVING(state) {
      state.isReceiving = false;
    },
    RECEIVING_SALESREPORTS(state) {
      state.isReceiving = true;
    },
    SALESREPORT_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    SALESREPORT_SUCCESS(state) {
      state.isFetching = false;
      state.hasAlert= false;
      state.errorMessage = '';
      state.isDone = true;
    },
    SALESREPORT_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert= false;
      state.errorMessage = '';
    },
    SALESREPORT_DONE(state) {
      state.isFetching= false,
      state.hasAlert = false,
      state.isDone = false,
      state.errorMessage = ''
    }
  },
  actions: {
    async getCustomerReportSummaryByTownship({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingSalesReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/customer/report/bytownship';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveSalesReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getCustomerReportSummaryByUser({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingSalesReports");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.accountxc.com:3100/customer/report/byuser';
        let response = await axios({method: "post", url: url, headers: headers, data: payload});
        dispatch("receiveSalesReports", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    deletingSalesReport({commit}, payload) {
      commit("DELETING_SALESREPORT", payload)
    },
    deleteSalesReport({commit}, payload) {
      commit("DELETED_SALESREPORT", payload)
    },
    receiveSalesReport({dispatch}) {
      dispatch('receiveSalesReportSuccess');
    },
    receiveSalesReports({commit}, payload) {
      commit("RECEIVED_SALESREPORTS", payload)
    },
    stopReceiving({commit}, payload) {
      commit("STOP_RECEIVING", payload)
    },
    receivingSalesReports({commit}) {
      commit("RECEIVING_SALESREPORTS")
    },
    logoutUser() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('usertype');
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      axios.defaults.headers.common['Authorization'] = "";
      router.push('/login');
    },
    loginError({commit}, payload) {
      commit('SALESREPORT_FAILURE', payload);
    },
    resetSalesReport({commit}) {
      commit('SALESREPORT_DONE');
    },
    receiveSalesReportSuccess({commit}) {
      commit('SALESREPORT_SUCCESS');
      //router.push('/login');
    },
    requestSalesReport({commit}) {
      commit('SALESREPORT_REQUEST');
    },
  }
}
